import {
  Avatar,
  Card,
  CardContent,
  Stack,
  SvgIcon,
  Typography,
} from "@mui/material";

function Overview({ sx, value, title, backgroundColor, children }) {
  return (
    <Card sx={sx}>
      <CardContent>
        <Stack
          alignItems="flex-start"
          direction="row"
          justifyContent="space-between"
          spacing={5}
        >
          <Stack spacing={3}>
            <Typography color="text.secondary" variant="h5">
              {title}
            </Typography>
            <Typography variant="h4">{value}</Typography>
          </Stack>
          <Avatar
            sx={{
              backgroundColor: backgroundColor,
              height: 56,
              width: 56,
            }}
          >
            <SvgIcon>{children}</SvgIcon>
          </Avatar>
        </Stack>
      </CardContent>
    </Card>
  );
}

export default Overview;
